import { A as k, D as T, M as P, P as C, T as B, a as S, f as E } from "./chunks/css-url-policy-BMYkY7Mb.js";
import { s as n } from "./chunks/session-parts-CfRSgvd1.js";
import { c as D, a as A } from "./chunks/session-parts-CfRSgvd1.js";
import { D as H, H as L, M as R, P as M, c as U, a as z, b as W, d as j, i as _, m as V, p as G, s as q } from "./chunks/field-ownership-BAZx24fO.js";
import { fetchWidgetAppDesign as Y } from "./chunks/fetch-widget-app-design-dka1lkRl.js";
const c = [
  {
    variable: "--color-base-100",
    label: "Base 100",
    type: "color",
    group: "colors",
    description: "Primary page/widget background",
    defaultHint: "oklch(100% 0 0)"
  },
  {
    variable: "--color-base-200",
    label: "Base 200",
    type: "color",
    group: "colors",
    description: "Secondary background — panels, input fields",
    defaultHint: "oklch(98% 0 0)"
  },
  {
    variable: "--color-base-300",
    label: "Base 300",
    type: "color",
    group: "colors",
    description: "Tertiary background — skeleton loaders, dividers",
    defaultHint: "oklch(95% 0 0)"
  },
  {
    variable: "--color-base-content",
    label: "Base content",
    type: "color",
    group: "colors",
    description: "Default body text on base backgrounds",
    defaultHint: "oklch(21% 0.006 285.885)"
  },
  {
    variable: "--color-primary",
    label: "Primary",
    type: "color",
    group: "colors",
    description: "Main brand colour — primary buttons, interactive elements",
    defaultHint: "oklch(45% 0.24 277.023)"
  },
  {
    variable: "--color-primary-content",
    label: "Primary content",
    type: "color",
    group: "colors",
    description: "Text/icon colour on primary backgrounds",
    defaultHint: "oklch(93% 0.034 272.788)"
  },
  {
    variable: "--color-secondary",
    label: "Secondary",
    type: "color",
    group: "colors",
    description: "Secondary brand colour — secondary buttons, highlights",
    defaultHint: "oklch(65% 0.241 354.308)"
  },
  {
    variable: "--color-secondary-content",
    label: "Secondary content",
    type: "color",
    group: "colors",
    description: "Text/icon colour on secondary backgrounds",
    defaultHint: "oklch(94% 0.028 342.258)"
  },
  {
    variable: "--color-accent",
    label: "Accent",
    type: "color",
    group: "colors",
    description: "Accent highlight for tertiary interactions",
    defaultHint: "oklch(77% 0.152 181.912)"
  },
  {
    variable: "--color-accent-content",
    label: "Accent content",
    type: "color",
    group: "colors",
    description: "Text/icon colour on accent backgrounds",
    defaultHint: "oklch(38% 0.063 188.416)"
  },
  {
    variable: "--color-neutral",
    label: "Neutral",
    type: "color",
    group: "colors",
    description: "Neutral colour for less prominent elements",
    defaultHint: "oklch(14% 0.005 285.823)"
  },
  {
    variable: "--color-neutral-content",
    label: "Neutral content",
    type: "color",
    group: "colors",
    description: "Text/icon colour on neutral backgrounds",
    defaultHint: "oklch(92% 0.004 286.32)"
  },
  {
    variable: "--color-info",
    label: "Info",
    type: "color",
    group: "colors",
    description: "Informational alerts and badges",
    defaultHint: "oklch(74% 0.16 232.661)"
  },
  {
    variable: "--color-info-content",
    label: "Info content",
    type: "color",
    group: "colors",
    description: "Text/icon colour on info backgrounds",
    defaultHint: "oklch(29% 0.066 243.157)"
  },
  {
    variable: "--color-success",
    label: "Success",
    type: "color",
    group: "colors",
    description: "Success states and confirmations",
    defaultHint: "oklch(76% 0.177 163.223)"
  },
  {
    variable: "--color-success-content",
    label: "Success content",
    type: "color",
    group: "colors",
    description: "Text/icon colour on success backgrounds",
    defaultHint: "oklch(37% 0.077 168.94)"
  },
  {
    variable: "--color-warning",
    label: "Warning",
    type: "color",
    group: "colors",
    description: "Warning states and caution indicators",
    defaultHint: "oklch(82% 0.189 84.429)"
  },
  {
    variable: "--color-warning-content",
    label: "Warning content",
    type: "color",
    group: "colors",
    description: "Text/icon colour on warning backgrounds",
    defaultHint: "oklch(41% 0.112 45.904)"
  },
  {
    variable: "--color-error",
    label: "Error",
    type: "color",
    group: "colors",
    description: "Error states and destructive actions",
    defaultHint: "oklch(71% 0.194 13.428)"
  },
  {
    variable: "--color-error-content",
    label: "Error content",
    type: "color",
    group: "colors",
    description: "Text/icon colour on error backgrounds",
    defaultHint: "oklch(27% 0.105 12.094)"
  },
  {
    variable: "--radius-selector",
    label: "Selector radius",
    type: "radius",
    group: "radius",
    description: "Border radius for checkboxes, radios, toggles",
    defaultHint: "0.5rem"
  },
  {
    variable: "--radius-field",
    label: "Field radius",
    type: "radius",
    group: "radius",
    description: "Border radius for buttons, inputs, selects",
    defaultHint: "0.25rem"
  },
  {
    variable: "--radius-box",
    label: "Box radius",
    type: "radius",
    group: "radius",
    description: "Border radius for cards, modals, drawers",
    defaultHint: "0.5rem"
  },
  {
    variable: "--size-selector",
    label: "Selector size",
    type: "size",
    group: "size",
    description: "Padding/spacing for checkboxes, radios, toggles",
    defaultHint: "0.25rem"
  },
  {
    variable: "--size-field",
    label: "Field size",
    type: "size",
    group: "size",
    description: "Padding/spacing for buttons, inputs, selects",
    defaultHint: "0.25rem"
  },
  {
    variable: "--border",
    label: "Border width",
    type: "utility",
    group: "utility",
    description: "Default border width for components",
    defaultHint: "1px"
  },
  {
    variable: "--depth",
    label: "Depth",
    type: "utility",
    group: "utility",
    description: "Shadow depth multiplier (0 = flat, 1 = normal)",
    defaultHint: "1"
  },
  {
    variable: "--noise",
    label: "Noise",
    type: "utility",
    group: "utility",
    description: "Background noise texture amount (0 = none)",
    defaultHint: "0"
  },
  // `layout` — Pype's own supported surface for the header chrome, read by
  // both shells. CX CSS aimed at shell internals (`.ps-*`, `:host`) is not.
  {
    variable: "--ps-header-block-size",
    label: "Header height",
    type: "size",
    group: "layout",
    description: "Floating: where the conversation card starts, between 3rem and 40% of the panel so the top-bar icons and the composer stay visible (no effect during the brand moment). Fullpage: minimum height of the top region",
    defaultHint: "3rem / 3.5rem"
  },
  {
    variable: "--ps-header-background",
    label: "Header background",
    type: "color",
    group: "layout",
    description: "Floating: the brand area, visible where its image is hidden (`home-brand-image`). Fullpage: the top region. Header text must keep 4.5:1 against it, and icons 3:1"
  },
  {
    variable: "--ps-header-foreground",
    label: "Header text",
    type: "color",
    group: "layout",
    description: "Text and icon colour in the header. Floating icons sit on a dark scrim over the brand area, so a dark colour here needs Header scrim set to `none`"
  },
  {
    variable: "--ps-header-scrim",
    label: "Header scrim",
    type: "utility",
    group: "layout",
    description: "Floating only: the dark gradient behind the top-bar icons. Set `none` for a flat header or dark icons — then Header background must carry the contrast"
  },
  {
    variable: "--ps-conversation-badge-display",
    label: "Conversation badge row",
    type: "utility",
    group: "layout",
    description: "Floating only: `none` removes the brand badge row (and its padding) above the conversation",
    defaultHint: "flex"
  }
], d = {
  colors: "Colors",
  radius: "Radius",
  size: "Size",
  utility: "Utility",
  layout: "Layout"
}, r = [
  {
    component: "ps-pype-agent-status-banner",
    part: "status-banner-root",
    description: "Outer wrapper",
    displayName: "Banner Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-audio",
    part: "audio-root",
    description: "Outer wrapper element",
    displayName: "Audio Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-audio",
    part: "audio-player",
    description: "The audio element",
    displayName: "Audio Player",
    cxOverridable: !0
  },
  {
    component: "ps-pype-brand-area",
    part: "brand-area-root",
    description: "Cover container",
    displayName: "Background Container",
    cxOverridable: !1
  },
  {
    component: "ps-pype-brand-area",
    part: "brand-area-image",
    description: "Brand-moment cover image",
    displayName: "Brand Moment Image",
    cxOverridable: !1
  },
  {
    component: "ps-pype-brand-area",
    part: "brand-area-badge",
    description: "Wrapper positioning the badge over the bottom edge",
    displayName: "Badge Position",
    cxOverridable: !1
  },
  {
    component: "ps-pype-brand-badge",
    part: "brand-badge-root",
    description: "Badge wrapper",
    displayName: "Badge",
    cxOverridable: !0
  },
  {
    component: "ps-pype-brand-badge",
    part: "brand-badge-logo",
    description: "Customer logo image",
    displayName: "Logo",
    cxOverridable: !0
  },
  {
    component: "ps-pype-brand-badge",
    part: "brand-badge-name",
    description: "Customer name. Hide it visually, never with `display: none` — the logo beside it is unnamed when a name shows",
    displayName: "Name",
    cxOverridable: !0
  },
  {
    component: "ps-pype-buttons-fullpage",
    part: "buttons-root",
    description: "Outer wrapper element",
    displayName: "Buttons Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-buttons-fullpage",
    part: "buttons-option",
    description: "Individual option button",
    displayName: "Option Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-buttons-fullpage",
    part: "buttons-option-link-icon",
    description: "Open-link icon on an option that opens a URL",
    displayName: "Link Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-buttons",
    part: "buttons-root",
    description: "Outer wrapper element",
    displayName: "Buttons Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-buttons",
    part: "buttons-option",
    description: "Individual option button (forwarded from inner `<ps-pype-button>`'s `button-root` part via `exportparts`)",
    displayName: "Option Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-buttons",
    part: "buttons-option-link-icon",
    description: "Open-link icon on an option that opens a URL",
    displayName: "Link Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-button",
    part: "button-root",
    description: "The button element",
    displayName: "Button",
    cxOverridable: !1
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-root",
    description: "Outer wrapper element",
    displayName: "Carousel Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-track",
    description: "Card viewport container",
    displayName: "Card Track",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-card",
    description: "Individual card container",
    displayName: "Card",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-card-image",
    description: "Card image element",
    displayName: "Card Image",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-card-title",
    description: "Card title heading",
    displayName: "Card Title",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-card-action",
    description: "Card action button",
    displayName: "Card Action Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-prev-btn",
    description: "Previous card",
    displayName: "Previous Button",
    cxOverridable: !0,
    states: [
      "enabled",
      "disabled"
    ]
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-next-btn",
    description: "Next card",
    displayName: "Next Button",
    cxOverridable: !0,
    states: [
      "enabled",
      "disabled"
    ]
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-prev-btn-enabled",
    description: "The carousel-prev-btn part while enabled",
    displayName: "Previous Button (enabled)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-prev-btn-disabled",
    description: "The carousel-prev-btn part while disabled",
    displayName: "Previous Button (disabled)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-next-btn-enabled",
    description: "The carousel-next-btn part while enabled",
    displayName: "Next Button (enabled)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-next-btn-disabled",
    description: "The carousel-next-btn part while disabled",
    displayName: "Next Button (disabled)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-prev-icon",
    description: "Previous-card arrow",
    displayName: "Previous Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-next-icon",
    description: "Next-card arrow",
    displayName: "Next Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-card-media",
    description: "Image area of a card with an image",
    displayName: "Card Media",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-card-title-panel",
    description: "Title panel over the card image",
    displayName: "Card Title Overlay",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-card-header",
    description: "Title band of a card without an image",
    displayName: "Card Header",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-card-details",
    description: "Text and actions area under the title",
    displayName: "Card Details",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-card-subtitle",
    description: "Card subtitle",
    displayName: "Card Subtitle",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-card-optional",
    description: "Card optional text",
    displayName: "Card Extra Text",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-card-actions",
    description: "Row holding the action buttons",
    displayName: "Card Actions",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-dots",
    description: "Row of page dots",
    displayName: "Page Dots",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-dot",
    description: "One page dot",
    displayName: "Page Dot",
    cxOverridable: !0,
    states: [
      "active",
      "inactive"
    ]
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-dot-active",
    description: "The carousel-dot part while active",
    displayName: "Page Dot (active)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel-fullpage",
    part: "carousel-dot-inactive",
    description: "The carousel-dot part while inactive",
    displayName: "Page Dot (inactive)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-root",
    description: "Outer wrapper element",
    displayName: "Carousel Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-track",
    description: "Card viewport container",
    displayName: "Card Track",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-card",
    description: "Individual card container",
    displayName: "Card",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-card-image",
    description: "Card image element",
    displayName: "Card Image",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-card-title",
    description: "Card title heading",
    displayName: "Card Title",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-card-action",
    description: "Card action button",
    displayName: "Card Action Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-prev-btn",
    description: "Previous card",
    displayName: "Previous Button",
    cxOverridable: !0,
    states: [
      "enabled",
      "disabled"
    ]
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-next-btn",
    description: "Next card",
    displayName: "Next Button",
    cxOverridable: !0,
    states: [
      "enabled",
      "disabled"
    ]
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-prev-btn-enabled",
    description: "The carousel-prev-btn part while enabled",
    displayName: "Previous Button (enabled)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-prev-btn-disabled",
    description: "The carousel-prev-btn part while disabled",
    displayName: "Previous Button (disabled)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-next-btn-enabled",
    description: "The carousel-next-btn part while enabled",
    displayName: "Next Button (enabled)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-next-btn-disabled",
    description: "The carousel-next-btn part while disabled",
    displayName: "Next Button (disabled)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-prev-icon",
    description: "Previous-card arrow",
    displayName: "Previous Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-next-icon",
    description: "Next-card arrow",
    displayName: "Next Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-card-media",
    description: "Image area of a card with an image",
    displayName: "Card Media",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-card-title-panel",
    description: "Title panel over the card image",
    displayName: "Card Title Overlay",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-card-header",
    description: "Title band of a card without an image",
    displayName: "Card Header",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-card-details",
    description: "Text and actions area under the title",
    displayName: "Card Details",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-card-subtitle",
    description: "Card subtitle",
    displayName: "Card Subtitle",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-card-optional",
    description: "Card optional text",
    displayName: "Card Extra Text",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-card-actions",
    description: "Row holding the action buttons",
    displayName: "Card Actions",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-dots",
    description: "Row of page dots",
    displayName: "Page Dots",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-dot",
    description: "One page dot",
    displayName: "Page Dot",
    cxOverridable: !0,
    states: [
      "active",
      "inactive"
    ]
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-dot-active",
    description: "The carousel-dot part while active",
    displayName: "Page Dot (active)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-carousel",
    part: "carousel-dot-inactive",
    description: "The carousel-dot part while inactive",
    displayName: "Page Dot (inactive)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-chat-bubble",
    part: "bubble-root",
    description: "Outermost chat wrapper (carries chat-start/chat-end)",
    displayName: "Bubble Container",
    cxOverridable: !0,
    sided: !0
  },
  {
    component: "ps-pype-chat-bubble",
    part: "bubble-avatar",
    description: "Avatar column beside the bubble (DaisyUI chat-image)",
    displayName: "Avatar",
    cxOverridable: !0
  },
  {
    component: "ps-pype-chat-bubble",
    part: "bubble-header",
    description: "Header row containing label and timestamp",
    displayName: "Header",
    cxOverridable: !0
  },
  {
    component: "ps-pype-chat-bubble",
    part: "bubble-timestamp",
    description: "The time element inside the header",
    displayName: "Timestamp",
    cxOverridable: !0
  },
  {
    component: "ps-pype-chat-bubble",
    part: "bubble-body",
    description: "Chat bubble body wrapping slotted content",
    displayName: "Message Body",
    cxOverridable: !0,
    sided: !0
  },
  {
    component: "ps-pype-chat-bubble",
    part: "bubble-loader",
    description: "Thinking/loading indicator shown in place of the body Every part in `sidedParts` is also exposed as `<part>-start` (bot & agent) and `<part>-end` (user):",
    displayName: "Thinking Indicator",
    cxOverridable: !1
  },
  {
    component: "ps-pype-chat-bubble",
    part: "bubble-root-start",
    description: "Outermost wrapper, bot & agent",
    displayName: "Bubble Container (bot & agent)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-chat-bubble",
    part: "bubble-root-end",
    description: "Outermost wrapper, user",
    displayName: "Bubble Container (user)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-chat-bubble",
    part: "bubble-body-start",
    description: "Body, bot & agent",
    displayName: "Message Body (bot & agent)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-chat-bubble",
    part: "bubble-body-end",
    description: "Body, user",
    displayName: "Message Body (user)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-chat-bubble",
    part: "bubble-avatar-icon",
    description: "Generic agent icon when no photo is set",
    displayName: "Avatar Placeholder Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-chat-bubble",
    part: "bubble-loader-dot",
    description: "One of the three thinking dots",
    displayName: "Thinking Dot",
    cxOverridable: !1
  },
  {
    component: "ps-pype-chat-ended-menu",
    part: "chat-ended-root",
    description: "Outer wrapper (section)",
    displayName: "Menu Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-chat-ended-menu",
    part: "chat-ended-message",
    description: '"Conversation ended" text paragraph',
    displayName: "Ended Message",
    cxOverridable: !0
  },
  {
    component: "ps-pype-chat-ended-menu",
    part: "chat-ended-nav",
    description: "Navigation container for action buttons",
    displayName: "Navigation",
    cxOverridable: !0
  },
  {
    component: "ps-pype-chat-ended-menu",
    part: "chat-ended-download-btn",
    description: "Download transcript button",
    displayName: "Download Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-chat-ended-menu",
    part: "chat-ended-new-btn",
    description: "Start new conversation button",
    displayName: "New Chat Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-chat-ended-menu",
    part: "chat-ended-download-icon",
    description: "Download icon",
    displayName: "Download Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-connecting",
    part: "connecting-root",
    description: "Centred wrapper",
    displayName: "Connecting",
    cxOverridable: !0
  },
  {
    component: "ps-pype-connecting",
    part: "connecting-ring",
    description: "The rotating indeterminate ring",
    displayName: "Ring",
    cxOverridable: !0
  },
  {
    component: "ps-pype-connecting",
    part: "connecting-logo",
    description: "Customer logo, or the bundled Pypestream mark",
    displayName: "Logo",
    cxOverridable: !0
  },
  {
    component: "ps-pype-connecting",
    part: "connecting-mark-icon",
    description: "The Pypestream mark shown when no logo is set",
    displayName: "Pypestream Mark",
    cxOverridable: !0
  },
  {
    component: "ps-pype-datepicker-fullpage",
    part: "datepicker-root",
    description: "Outer wrapper element",
    displayName: "Picker Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-datepicker-fullpage",
    part: "datepicker-input",
    description: "The value control of a spinner column",
    displayName: "Date Input",
    cxOverridable: !0
  },
  {
    component: "ps-pype-datepicker-fullpage",
    part: "datepicker-step-icon",
    description: "Up/down arrow on the step buttons",
    displayName: "Step Arrow Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-datepicker-fullpage",
    part: "datepicker-well",
    description: "The box holding the month/day/year columns",
    displayName: "Picker Well",
    cxOverridable: !0
  },
  {
    component: "ps-pype-datepicker-fullpage",
    part: "datepicker-column",
    description: "One month, day or year column",
    displayName: "Column",
    cxOverridable: !0
  },
  {
    component: "ps-pype-datepicker-fullpage",
    part: "datepicker-step-btn",
    description: "Up/down step button",
    displayName: "Step Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-datepicker-fullpage",
    part: "datepicker-value-text",
    description: "The value shown in a column",
    displayName: "Value Text",
    cxOverridable: !0
  },
  {
    component: "ps-pype-datepicker-fullpage",
    part: "datepicker-list",
    description: "The open list of values",
    displayName: "Options List",
    cxOverridable: !0
  },
  {
    component: "ps-pype-datepicker-fullpage",
    part: "datepicker-option",
    description: "One value in the open list",
    displayName: "Option",
    cxOverridable: !0,
    states: [
      "selected",
      "unselected"
    ]
  },
  {
    component: "ps-pype-datepicker-fullpage",
    part: "datepicker-option-selected",
    description: "The datepicker-option part while selected",
    displayName: "Option (selected)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-datepicker-fullpage",
    part: "datepicker-option-unselected",
    description: "The datepicker-option part while unselected",
    displayName: "Option (unselected)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-datepicker",
    part: "datepicker-root",
    description: "Outer wrapper element",
    displayName: "Picker Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-datepicker",
    part: "datepicker-input",
    description: "The value control of a spinner column",
    displayName: "Date Input",
    cxOverridable: !0
  },
  {
    component: "ps-pype-datepicker",
    part: "datepicker-step-icon",
    description: "Up/down arrow on the step buttons",
    displayName: "Step Arrow Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-datepicker",
    part: "datepicker-well",
    description: "The box holding the month/day/year columns",
    displayName: "Picker Well",
    cxOverridable: !0
  },
  {
    component: "ps-pype-datepicker",
    part: "datepicker-column",
    description: "One month, day or year column",
    displayName: "Column",
    cxOverridable: !0
  },
  {
    component: "ps-pype-datepicker",
    part: "datepicker-step-btn",
    description: "Up/down step button",
    displayName: "Step Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-datepicker",
    part: "datepicker-value-text",
    description: "The value shown in a column",
    displayName: "Value Text",
    cxOverridable: !0
  },
  {
    component: "ps-pype-datepicker",
    part: "datepicker-list",
    description: "The open list of values",
    displayName: "Options List",
    cxOverridable: !0
  },
  {
    component: "ps-pype-datepicker",
    part: "datepicker-option",
    description: "One value in the open list",
    displayName: "Option",
    cxOverridable: !0,
    states: [
      "selected",
      "unselected"
    ]
  },
  {
    component: "ps-pype-datepicker",
    part: "datepicker-option-selected",
    description: "The datepicker-option part while selected",
    displayName: "Option (selected)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-datepicker",
    part: "datepicker-option-unselected",
    description: "The datepicker-option part while unselected",
    displayName: "Option (unselected)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-deeplink",
    part: "deeplink-root",
    description: "Outer wrapper element",
    displayName: "Link Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-deeplink",
    part: "deeplink-anchor",
    description: "The anchor element",
    displayName: "Link",
    cxOverridable: !0
  },
  {
    component: "ps-pype-document",
    part: "document-root",
    description: "Outer wrapper element",
    displayName: "Document Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-document",
    part: "document-link",
    description: "The anchor element",
    displayName: "Download Link",
    cxOverridable: !0
  },
  {
    component: "ps-pype-document",
    part: "document-download-icon",
    description: "Download icon",
    displayName: "Download Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-document",
    part: "document-external-icon",
    description: "Opens-in-new-tab icon",
    displayName: "External Link Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-dyte",
    part: "dyte-root",
    description: "The chat bubble",
    displayName: "Message Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-dyte",
    part: "dyte-link",
    description: "The join link button",
    displayName: "Join Link",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-transfer",
    part: "file-transfer-root",
    description: "Outer wrapper element",
    displayName: "File Card",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-transfer",
    part: "file-transfer-preview",
    description: "Image preview",
    displayName: "Image Preview",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-transfer",
    part: "file-transfer-icon",
    description: "Media-type icon",
    displayName: "File Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-transfer",
    part: "file-transfer-name",
    description: "File name text",
    displayName: "File Name",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-transfer",
    part: "file-transfer-type",
    description: "File type badge",
    displayName: "File Type Badge",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-transfer",
    part: "file-transfer-download",
    description: "Download button",
    displayName: "Download Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-transfer",
    part: "file-transfer-action-icon",
    description: "Download / done / failed icon on the download button",
    displayName: "Download Button Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-transfer",
    part: "file-transfer-spinner",
    description: "Shown while downloading",
    displayName: "Download Spinner",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload-fullpage",
    part: "file-upload-root",
    description: "Outer wrapper element",
    displayName: "Upload Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload-fullpage",
    part: "file-upload-dropzone",
    description: "The drop zone surface",
    displayName: "Drop Zone",
    cxOverridable: !0,
    states: [
      "idle",
      "drag"
    ]
  },
  {
    component: "ps-pype-file-upload-fullpage",
    part: "file-upload-cancel",
    description: "Cancel button",
    displayName: "Cancel Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload-fullpage",
    part: "file-upload-dismiss",
    description: "Dismisses the in-progress or failed upload",
    displayName: "Dismiss Upload Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload-fullpage",
    part: "file-upload-dropzone-icon",
    description: "Upload icon in the drop zone",
    displayName: "Drop Zone Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload-fullpage",
    part: "file-upload-card",
    description: "The attachment card",
    displayName: "Upload Card",
    cxOverridable: !0,
    states: [
      "uploading",
      "success",
      "error"
    ]
  },
  {
    component: "ps-pype-file-upload-fullpage",
    part: "file-upload-card-thumb",
    description: "Image preview",
    displayName: "Upload Card Thumbnail",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload-fullpage",
    part: "file-upload-card-glyph-icon",
    description: "File icon when there is no preview",
    displayName: "Upload Card File Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload-fullpage",
    part: "file-upload-card-name",
    description: "File name",
    displayName: "Upload Card File Name",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload-fullpage",
    part: "file-upload-card-progress",
    description: "Upload progress bar",
    displayName: "Upload Card Progress Bar",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload-fullpage",
    part: "file-upload-card-meta",
    description: "Size, progress, success or failure text",
    displayName: "Upload Card Status Text",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload-fullpage",
    part: "file-upload-dismiss-icon",
    description: "Icon on the dismiss button",
    displayName: "Dismiss Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload-fullpage",
    part: "file-upload-card-uploading",
    description: "The file-upload-card part while uploading",
    displayName: "Upload Card (uploading)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload-fullpage",
    part: "file-upload-card-success",
    description: "The file-upload-card part while success",
    displayName: "Upload Card (success)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload-fullpage",
    part: "file-upload-card-error",
    description: "The file-upload-card part while error",
    displayName: "Upload Card (error)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload-fullpage",
    part: "file-upload-dropzone-primary",
    description: "Main drop zone text",
    displayName: "Drop Zone Label",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload-fullpage",
    part: "file-upload-dropzone-secondary",
    description: '"Drag or click" hint',
    displayName: "Drop Zone Hint",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload-fullpage",
    part: "file-upload-dropzone-idle",
    description: "The file-upload-dropzone part while idle",
    displayName: "Drop Zone (idle)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload-fullpage",
    part: "file-upload-dropzone-drag",
    description: "The file-upload-dropzone part while drag",
    displayName: "Drop Zone (drag)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload",
    part: "file-upload-root",
    description: "Outer wrapper element",
    displayName: "Upload Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload",
    part: "file-upload-select",
    description: "File select button",
    displayName: "Select File Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload",
    part: "file-upload-cancel",
    description: "Cancel button",
    displayName: "Cancel Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload",
    part: "file-upload-dismiss",
    description: "Dismisses the in-progress or failed upload",
    displayName: "Dismiss Upload Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload",
    part: "file-upload-card",
    description: "The attachment card",
    displayName: "Upload Card",
    cxOverridable: !0,
    states: [
      "uploading",
      "success",
      "error"
    ]
  },
  {
    component: "ps-pype-file-upload",
    part: "file-upload-card-thumb",
    description: "Image preview",
    displayName: "Upload Card Thumbnail",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload",
    part: "file-upload-card-glyph-icon",
    description: "File icon when there is no preview",
    displayName: "Upload Card File Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload",
    part: "file-upload-card-name",
    description: "File name",
    displayName: "Upload Card File Name",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload",
    part: "file-upload-card-progress",
    description: "Upload progress bar",
    displayName: "Upload Card Progress Bar",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload",
    part: "file-upload-card-meta",
    description: "Size, progress, success or failure text",
    displayName: "Upload Card Status Text",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload",
    part: "file-upload-dismiss-icon",
    description: "Icon on the dismiss button",
    displayName: "Dismiss Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload",
    part: "file-upload-card-uploading",
    description: "The file-upload-card part while uploading",
    displayName: "Upload Card (uploading)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload",
    part: "file-upload-card-success",
    description: "The file-upload-card part while success",
    displayName: "Upload Card (success)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-file-upload",
    part: "file-upload-card-error",
    description: "The file-upload-card part while error",
    displayName: "Upload Card (error)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-menu",
    part: "fullpage-menu-root",
    description: "Outer panel wrapper",
    displayName: "Menu Panel",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-menu",
    part: "fullpage-menu-header",
    description: "Header row (title + close)",
    displayName: "Menu Header",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-menu",
    part: "fullpage-menu-grid",
    description: "Persistent-menu options grid",
    displayName: "Menu Grid",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-menu",
    part: "fullpage-menu-download-btn",
    description: "Download Transcript button",
    displayName: "Download Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-menu",
    part: "fullpage-menu-close-btn",
    description: "Closes the menu",
    displayName: "Close Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-menu",
    part: "fullpage-menu-option",
    description: "A persistent-menu option card",
    displayName: "Menu Option",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-menu",
    part: "fullpage-menu-close-icon",
    description: "Close icon",
    displayName: "Close Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-menu",
    part: "fullpage-menu-download-icon",
    description: "Download icon",
    displayName: "Download Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-menu",
    part: "fullpage-menu-title",
    description: "The menu heading",
    displayName: "Menu Title",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-nav",
    part: "fullpage-nav-root",
    description: "Outer `<nav>` wrapper",
    displayName: "Nav Bar",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-nav",
    part: "fullpage-nav-logo",
    description: "Customer logo image",
    displayName: "Logo",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-nav",
    part: "fullpage-nav-name",
    description: "Customer name",
    displayName: "Customer Name",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-nav",
    part: "fullpage-nav-end-btn",
    description: "End Chat button",
    displayName: "End Chat Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-nav",
    part: "fullpage-nav-menu-btn",
    description: "Opens the menu",
    displayName: "Menu Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-nav",
    part: "fullpage-nav-menu-icon",
    description: "Home icon on the menu button",
    displayName: "Menu Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-nav",
    part: "fullpage-nav-end-icon",
    description: "Icon on the End chat button",
    displayName: "End Chat Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-nav",
    part: "fullpage-nav-subtitle",
    description: "Agent-context subtitle",
    displayName: "Subtitle",
    cxOverridable: !0
  },
  {
    component: "ps-pype-home",
    part: "home-root",
    description: "Outer wrapper",
    displayName: "Home Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-home",
    part: "home-menu-grid",
    description: "Persistent menu options grid",
    displayName: "Menu Grid",
    cxOverridable: !0
  },
  {
    component: "ps-pype-home",
    part: "home-menu-option",
    description: "Individual menu option button (forwarded from inner `<ps-pype-button>`'s `button-root` via `exportparts`)",
    displayName: "Menu Option",
    cxOverridable: !0
  },
  {
    component: "ps-pype-home",
    part: "home-settings",
    description: "Settings section",
    displayName: "Settings",
    cxOverridable: !0
  },
  {
    component: "ps-pype-home",
    part: "home-download-btn",
    description: '"Download Transcript" button',
    displayName: "Download Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-home",
    part: "home-return-btn",
    description: '"Return to Conversation" button',
    displayName: "Return Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-home",
    part: "home-brand",
    description: "Brand-moment hero banner: height, corners, border",
    displayName: "Hero Banner",
    cxOverridable: !0
  },
  {
    component: "ps-pype-home",
    part: "home-brand-image",
    description: "Hero cover image (forwarded from brand-area)",
    displayName: "Hero Image",
    cxOverridable: !0
  },
  {
    component: "ps-pype-home",
    part: "home-brand-badge",
    description: "Wrapper that straddles the badge over the band edge",
    displayName: "Hero Badge Position",
    cxOverridable: !0
  },
  {
    component: "ps-pype-home",
    part: "home-badge-root",
    description: "Hero brand badge (forwarded from brand-badge)",
    displayName: "Hero Badge",
    cxOverridable: !0
  },
  {
    component: "ps-pype-home",
    part: "home-badge-logo",
    description: "Hero brand badge logo",
    displayName: "Hero Badge Logo",
    cxOverridable: !0
  },
  {
    component: "ps-pype-home",
    part: "home-badge-name",
    description: "Hero brand badge name. Hide it visually, never with `display: none` — the logo beside it is unnamed when a name shows",
    displayName: "Hero Badge Name",
    cxOverridable: !0
  },
  {
    component: "ps-pype-home",
    part: "home-footer",
    description: '"Powered by" footer. CSS can hide it; by default its visibility follows the session\'s `widget_branding`',
    displayName: "Powered-by Footer",
    cxOverridable: !0
  },
  {
    component: "ps-pype-home",
    part: "home-footer-link",
    description: "The pypestream.com link in the footer",
    displayName: "Powered-by Link",
    cxOverridable: !0
  },
  {
    component: "ps-pype-home",
    part: "home-download-icon",
    description: "Download icon",
    displayName: "Download Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-home",
    part: "home-return-icon",
    description: "Icon on the Return to conversation button",
    displayName: "Return Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-home",
    part: "home-panel",
    description: "Panel under the hero",
    displayName: "Content Panel",
    cxOverridable: !0
  },
  {
    component: "ps-pype-home",
    part: "home-settings-title",
    description: "The Settings heading",
    displayName: "Settings Title",
    cxOverridable: !0
  },
  {
    component: "ps-pype-image",
    part: "image-root",
    description: "Outer figure element",
    displayName: "Image Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-image",
    part: "image-img",
    description: "The img element",
    displayName: "Image",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-root",
    description: "Outer wrapper element",
    displayName: "Input Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-textarea",
    description: "The textarea element (text mode)",
    displayName: "Text Area",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-field",
    description: "The input element (password mode)",
    displayName: "Input Field",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-prompt",
    description: 'The non-editable "Select option" prompt bar shown in `prompt` mode (a bot embed forces interaction via disable_input)',
    displayName: "Prompt Bar",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-status",
    description: "Network status text shown while offline/reconnecting",
    displayName: "Network Status",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-reconnect",
    description: "The Reconnect button (offline/reconnecting); the send button is replaced by it so the input region stays one slot",
    displayName: "Reconnect Button",
    cxOverridable: !0,
    states: [
      "enabled",
      "disabled"
    ]
  },
  {
    component: "ps-pype-input",
    part: "input-send",
    description: "The send button",
    displayName: "Send Button",
    cxOverridable: !0,
    states: [
      "enabled",
      "disabled"
    ]
  },
  {
    component: "ps-pype-input",
    part: "input-clear",
    description: "The clear (×) button (shown when `clearable`)",
    displayName: "Clear Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-reveal-btn",
    description: "Shows or hides the password (password mode)",
    displayName: "Reveal Password Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-attach",
    description: "The paperclip button (live agent chat only)",
    displayName: "Attach File Button",
    cxOverridable: !0,
    states: [
      "enabled",
      "disabled"
    ]
  },
  {
    component: "ps-pype-input",
    part: "input-attach-bar",
    description: "Status bar for the staged file, above the composer",
    displayName: "Attachment Status Bar",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-attach-remove",
    description: "Removes the staged file",
    displayName: "Remove Attachment Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "tooltip-bubble",
    description: "Hover/focus tooltip on the composer icon buttons",
    displayName: "tooltip-bubble",
    cxOverridable: !1
  },
  {
    component: "ps-pype-input",
    part: "input-send-enabled",
    description: "The input-send part while enabled",
    displayName: "Send Button (enabled)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-send-disabled",
    description: "The input-send part while disabled",
    displayName: "Send Button (disabled)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-attach-enabled",
    description: "The input-attach part while enabled",
    displayName: "Attach File Button (enabled)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-attach-disabled",
    description: "The input-attach part while disabled",
    displayName: "Attach File Button (disabled)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-reconnect-enabled",
    description: "The input-reconnect part while enabled",
    displayName: "Reconnect Button (enabled)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-reconnect-disabled",
    description: "The input-reconnect part while disabled",
    displayName: "Reconnect Button (disabled)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-attach-icon",
    description: "Paperclip icon",
    displayName: "Attach Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-send-icon",
    description: "Send icon",
    displayName: "Send Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-reveal-icon",
    description: "Show/hide password icon",
    displayName: "Reveal Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-clear-icon",
    description: "Clear icon",
    displayName: "Clear Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-attach-card",
    description: "The attachment card",
    displayName: "Attachment Card",
    cxOverridable: !0,
    states: [
      "uploading",
      "success",
      "error"
    ]
  },
  {
    component: "ps-pype-input",
    part: "input-attach-card-thumb",
    description: "Image preview",
    displayName: "Attachment Card Thumbnail",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-attach-card-glyph-icon",
    description: "File icon when there is no preview",
    displayName: "Attachment Card File Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-attach-card-name",
    description: "File name",
    displayName: "Attachment Card File Name",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-attach-card-progress",
    description: "Upload progress bar",
    displayName: "Attachment Card Progress Bar",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-attach-card-meta",
    description: "Size, progress, success or failure text",
    displayName: "Attachment Card Status Text",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-attach-remove-icon",
    description: "Icon on the remove button",
    displayName: "Remove Attachment Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-attach-card-uploading",
    description: "The input-attach-card part while uploading",
    displayName: "Attachment Card (uploading)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-attach-card-success",
    description: "The input-attach-card part while success",
    displayName: "Attachment Card (success)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-input",
    part: "input-attach-card-error",
    description: "The input-attach-card part while error",
    displayName: "Attachment Card (error)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-listpicker-fullpage",
    part: "listpicker-root",
    description: "Outer wrapper element",
    displayName: "List Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-listpicker-fullpage",
    part: "listpicker-search-input",
    description: "The search `<input>` (when >= 8 options)",
    displayName: "Search Input",
    cxOverridable: !0
  },
  {
    component: "ps-pype-listpicker-fullpage",
    part: "listpicker-list",
    description: 'The `<ul role="list">` container',
    displayName: "Options List",
    cxOverridable: !0
  },
  {
    component: "ps-pype-listpicker-fullpage",
    part: "listpicker-option",
    description: "The option's box (multi row / single button)",
    displayName: "Option Item",
    cxOverridable: !0,
    states: [
      "selected",
      "unselected"
    ]
  },
  {
    component: "ps-pype-listpicker-fullpage",
    part: "listpicker-label",
    description: "The option label",
    displayName: "Option Label",
    cxOverridable: !0
  },
  {
    component: "ps-pype-listpicker-fullpage",
    part: "listpicker-description",
    description: "The option description",
    displayName: "Option Description",
    cxOverridable: !0
  },
  {
    component: "ps-pype-listpicker-fullpage",
    part: "listpicker-checkbox",
    description: "Multi-select checkbox",
    displayName: "Checkbox",
    cxOverridable: !0
  },
  {
    component: "ps-pype-listpicker-fullpage",
    part: "listpicker-thumb",
    description: "Option thumbnail image",
    displayName: "Option Image",
    cxOverridable: !0
  },
  {
    component: "ps-pype-listpicker-fullpage",
    part: "listpicker-search-count",
    description: "Result count shown while searching",
    displayName: "Search Result Count",
    cxOverridable: !0
  },
  {
    component: "ps-pype-listpicker-fullpage",
    part: "listpicker-empty",
    description: "Shown when a search matches nothing",
    displayName: "No Results Message",
    cxOverridable: !0
  },
  {
    component: "ps-pype-listpicker-fullpage",
    part: "listpicker-option-selected",
    description: "The listpicker-option part while selected",
    displayName: "Option (selected)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-listpicker-fullpage",
    part: "listpicker-option-unselected",
    description: "The listpicker-option part while unselected",
    displayName: "Option (unselected)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-listpicker",
    part: "listpicker-root",
    description: "Outer wrapper element",
    displayName: "List Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-listpicker",
    part: "listpicker-search-input",
    description: "The search `<input>` (when >= 8 options)",
    displayName: "Search Input",
    cxOverridable: !0
  },
  {
    component: "ps-pype-listpicker",
    part: "listpicker-list",
    description: 'The `<ul role="list">` container',
    displayName: "Options List",
    cxOverridable: !0
  },
  {
    component: "ps-pype-listpicker",
    part: "listpicker-option",
    description: "The option's box (multi row / single button)",
    displayName: "Option Item",
    cxOverridable: !0,
    states: [
      "selected",
      "unselected"
    ]
  },
  {
    component: "ps-pype-listpicker",
    part: "listpicker-label",
    description: "The option label",
    displayName: "Option Label",
    cxOverridable: !0
  },
  {
    component: "ps-pype-listpicker",
    part: "listpicker-description",
    description: "The option description",
    displayName: "Option Description",
    cxOverridable: !0
  },
  {
    component: "ps-pype-listpicker",
    part: "listpicker-checkbox",
    description: "Multi-select checkbox",
    displayName: "Checkbox",
    cxOverridable: !0
  },
  {
    component: "ps-pype-listpicker",
    part: "listpicker-thumb",
    description: "Option thumbnail image",
    displayName: "Option Image",
    cxOverridable: !0
  },
  {
    component: "ps-pype-listpicker",
    part: "listpicker-search-count",
    description: "Result count shown while searching",
    displayName: "Search Result Count",
    cxOverridable: !0
  },
  {
    component: "ps-pype-listpicker",
    part: "listpicker-empty",
    description: "Shown when a search matches nothing",
    displayName: "No Results Message",
    cxOverridable: !0
  },
  {
    component: "ps-pype-listpicker",
    part: "listpicker-option-selected",
    description: "The listpicker-option part while selected",
    displayName: "Option (selected)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-listpicker",
    part: "listpicker-option-unselected",
    description: "The listpicker-option part while unselected",
    displayName: "Option (unselected)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-location-fullpage",
    part: "location-root",
    description: "Outer wrapper element",
    displayName: "Location Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-location-fullpage",
    part: "location-status",
    description: "Acquisition / blocked-send text",
    displayName: "Status Message",
    cxOverridable: !0
  },
  {
    component: "ps-pype-location-fullpage",
    part: "location-spinner",
    description: "Shown while locating",
    displayName: "Spinner",
    cxOverridable: !0
  },
  {
    component: "ps-pype-location",
    part: "location-root",
    description: "Outer wrapper element",
    displayName: "Location Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-location",
    part: "location-status",
    description: "Acquisition / blocked-send text",
    displayName: "Status Message",
    cxOverridable: !0
  },
  {
    component: "ps-pype-location",
    part: "location-spinner",
    description: "Shown while locating",
    displayName: "Spinner",
    cxOverridable: !0
  },
  {
    component: "ps-pype-notice",
    part: "notice-root",
    description: "Outer wrapper element",
    displayName: "Notice Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-overlay",
    part: "overlay-backdrop",
    description: "Semi-transparent backdrop",
    displayName: "Backdrop",
    cxOverridable: !0
  },
  {
    component: "ps-pype-overlay",
    part: "overlay-root",
    description: "Outer wrapper element",
    displayName: "Overlay Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-overlay",
    part: "overlay-toolbar",
    description: "Header bar (title + expand/reduce/close buttons)",
    displayName: "Toolbar",
    cxOverridable: !0
  },
  {
    component: "ps-pype-overlay",
    part: "overlay-title",
    description: "Title heading (rendered only when set)",
    displayName: "Title",
    cxOverridable: !0
  },
  {
    component: "ps-pype-overlay",
    part: "overlay-expand-btn",
    description: "Expand to full-screen button",
    displayName: "Expand Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-overlay",
    part: "overlay-reduce-btn",
    description: "Reduce back to overlay button",
    displayName: "Reduce Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-overlay",
    part: "overlay-close-btn",
    description: "Close overlay button",
    displayName: "Close Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-overlay",
    part: "overlay-newtab-btn",
    description: "Visible-on-focus keyboard-trap escape (expanded only)",
    displayName: "Open in New Tab Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-overlay",
    part: "overlay-content",
    description: "Scrollable content area wrapping the slot",
    displayName: "Content Area",
    cxOverridable: !0
  },
  {
    component: "ps-pype-overlay",
    part: "tooltip-bubble",
    description: "Hover/focus tooltip on the toolbar buttons",
    displayName: "tooltip-bubble",
    cxOverridable: !1
  },
  {
    component: "ps-pype-overlay",
    part: "overlay-expand-icon",
    description: "Expand icon",
    displayName: "Expand Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-overlay",
    part: "overlay-reduce-icon",
    description: "Reduce icon",
    displayName: "Reduce Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-overlay",
    part: "overlay-close-icon",
    description: "Close icon",
    displayName: "Close Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-response-placeholder",
    part: "indicator-root",
    description: "Outer wrapper",
    displayName: "indicator-root",
    cxOverridable: !1
  },
  {
    component: "ps-pype-response-placeholder",
    part: "indicator-dot",
    description: "One of the three thinking dots",
    displayName: "indicator-dot",
    cxOverridable: !1
  },
  {
    component: "ps-pype-scroll-to-bottom",
    part: "scroll-btn-root",
    description: "The button element",
    displayName: "Scroll Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-scroll-to-bottom",
    part: "scroll-btn-icon",
    description: "The chevron SVG",
    displayName: "Chevron Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-scroll-to-bottom",
    part: "scroll-btn-badge",
    description: "The unread-count badge",
    displayName: "Unread Badge",
    cxOverridable: !0
  },
  {
    component: "ps-pype-solution-request",
    part: "solution-root",
    description: "Outer wrapper (the chat bubble)",
    displayName: "Message Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-solution-request",
    part: "solution-link",
    description: "The clickable link button",
    displayName: "Open Link",
    cxOverridable: !0
  },
  {
    component: "ps-pype-star-fullpage",
    part: "star-root",
    description: "Outer wrapper element",
    displayName: "Rating Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-star-fullpage",
    part: "star-button",
    description: "Individual star button",
    displayName: "Star Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-star-fullpage",
    part: "star-button-filled",
    description: "A star inside the chosen (or hovered) rating",
    displayName: "Filled Star",
    cxOverridable: !0
  },
  {
    component: "ps-pype-star-fullpage",
    part: "star-button-empty",
    description: "A star outside it. `color` is the outline, `fill` the inside; keeps `opacity: 0.45` unless overridden",
    displayName: "Empty Star",
    cxOverridable: !0
  },
  {
    component: "ps-pype-star-fullpage",
    part: "star-cta",
    description: "Confirm/submit button",
    displayName: "Submit Button",
    cxOverridable: !0,
    states: [
      "enabled",
      "disabled"
    ]
  },
  {
    component: "ps-pype-star-fullpage",
    part: "star-cta-enabled",
    description: "The star-cta part while enabled",
    displayName: "Submit Button (enabled)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-star-fullpage",
    part: "star-cta-disabled",
    description: "The star-cta part while disabled",
    displayName: "Submit Button (disabled)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-star-fullpage",
    part: "star-icon",
    description: "The star glyph: `stroke-width` for the outline, size via width/height",
    displayName: "Star Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-star",
    part: "star-root",
    description: "Outer wrapper element",
    displayName: "Rating Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-star",
    part: "star-button",
    description: "Individual star button",
    displayName: "Star Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-star",
    part: "star-button-filled",
    description: "A star inside the chosen (or hovered) rating",
    displayName: "Filled Star",
    cxOverridable: !0
  },
  {
    component: "ps-pype-star",
    part: "star-button-empty",
    description: "A star outside it. `color` is the outline, `fill` the inside; keeps `opacity: 0.45` unless overridden",
    displayName: "Empty Star",
    cxOverridable: !0
  },
  {
    component: "ps-pype-star",
    part: "star-cta",
    description: "Confirm/submit button",
    displayName: "Submit Button",
    cxOverridable: !0,
    states: [
      "enabled",
      "disabled"
    ]
  },
  {
    component: "ps-pype-star",
    part: "star-cta-enabled",
    description: "The star-cta part while enabled",
    displayName: "Submit Button (enabled)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-star",
    part: "star-cta-disabled",
    description: "The star-cta part while disabled",
    displayName: "Submit Button (disabled)",
    cxOverridable: !0
  },
  {
    component: "ps-pype-star",
    part: "star-icon",
    description: "The star glyph: `stroke-width` for the outline, size via width/height",
    displayName: "Star Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-timepicker-fullpage",
    part: "timepicker-root",
    description: "Outer wrapper element",
    displayName: "Picker Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-timepicker-fullpage",
    part: "timepicker-input",
    description: "The time input element",
    displayName: "Time Input",
    cxOverridable: !0
  },
  {
    component: "ps-pype-timepicker-fullpage",
    part: "timepicker-confirm",
    description: "Confirm button",
    displayName: "Confirm Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-timepicker-fullpage",
    part: "timepicker-label",
    description: "The time label",
    displayName: "Label",
    cxOverridable: !0
  },
  {
    component: "ps-pype-timepicker",
    part: "timepicker-root",
    description: "Outer wrapper element",
    displayName: "Picker Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-timepicker",
    part: "timepicker-input",
    description: "The time input element",
    displayName: "Time Input",
    cxOverridable: !0
  },
  {
    component: "ps-pype-timepicker",
    part: "timepicker-confirm",
    description: "Confirm button",
    displayName: "Confirm Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-top-bar",
    part: "top-bar-root",
    description: "Outer wrapper",
    displayName: "Top Bar",
    cxOverridable: !0
  },
  {
    component: "ps-pype-top-bar",
    part: "tooltip-bubble",
    description: "Hover/focus tooltip on the icon buttons",
    displayName: "tooltip-bubble",
    cxOverridable: !1
  },
  {
    component: "ps-pype-top-bar",
    part: "top-bar-home-btn",
    description: "Home button (conversation) or back button (home)",
    displayName: "Home / Back Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-top-bar",
    part: "top-bar-minimize-btn",
    description: "Minimize button",
    displayName: "Minimize Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-top-bar",
    part: "top-bar-close-btn",
    description: "Close button",
    displayName: "Close Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-top-bar",
    part: "top-bar-home-icon",
    description: "Home or back icon",
    displayName: "Home / Back Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-top-bar",
    part: "top-bar-minimize-icon",
    description: "Minimize icon",
    displayName: "Minimize Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-top-bar",
    part: "top-bar-close-icon",
    description: "Close icon",
    displayName: "Close Icon",
    cxOverridable: !0
  },
  {
    component: "ps-pype-tray",
    part: "tray-root",
    description: "Outer wrapper element",
    displayName: "Tray Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-tray",
    part: "tray-condensed",
    description: "Condensed action hint bar",
    displayName: "Condensed Bar",
    cxOverridable: !0
  },
  {
    component: "ps-pype-tray",
    part: "tray-collapse",
    description: "Collapse handle",
    displayName: "Collapse Handle",
    cxOverridable: !0
  },
  {
    component: "ps-pype-tray",
    part: "tray-content",
    description: "Content area wrapping the slot",
    displayName: "Content Area",
    cxOverridable: !0
  },
  {
    component: "ps-pype-tray",
    part: "tray-grip",
    description: "The grip bar on the tray header",
    displayName: "Drag Handle",
    cxOverridable: !0
  },
  {
    component: "ps-pype-typing-indicator",
    part: "indicator-root",
    description: "Outer wrapper",
    displayName: "Indicator Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-typing-indicator",
    part: "indicator-bubble",
    description: "The bubble around the dots",
    displayName: "Bubble",
    cxOverridable: !0
  },
  {
    component: "ps-pype-typing-indicator",
    part: "indicator-name",
    description: "Agent name above the bubble",
    displayName: "Agent Name",
    cxOverridable: !0
  },
  {
    component: "ps-pype-typing-indicator",
    part: "indicator-dot",
    description: "One of the three animated dots",
    displayName: "Dot",
    cxOverridable: !0
  },
  {
    component: "ps-pype-unsupported",
    part: "unsupported-root",
    description: "Outer wrapper element",
    displayName: "Content Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-unsupported",
    part: "unsupported-label",
    description: "The unsupported-content text",
    displayName: "Message",
    cxOverridable: !0
  },
  {
    component: "ps-pype-unsupported",
    part: "unsupported-badge",
    description: "The message type badge",
    displayName: "Type Badge",
    cxOverridable: !0
  },
  {
    component: "ps-pype-video",
    part: "video-root",
    description: "Outer wrapper element",
    displayName: "Video Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-video",
    part: "video-player",
    description: "The video element",
    displayName: "Video Player",
    cxOverridable: !0
  },
  {
    component: "ps-pype-video",
    part: "video-fallback",
    description: "Alert region shown when playback fails",
    displayName: "Playback Error",
    cxOverridable: !0
  },
  {
    component: "ps-pype-video",
    part: "video-newtab-btn",
    description: "Shown when playback fails",
    displayName: "Open in New Tab Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-webview-fullpage",
    part: "webview-root",
    description: "Outer wrapper element",
    displayName: "Webview Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-webview-fullpage",
    part: "webview-title",
    description: "The page title heading",
    displayName: "Page Title",
    cxOverridable: !0
  },
  {
    component: "ps-pype-webview-fullpage",
    part: "webview-newtab-btn",
    description: "Open the embedded page in a new browser tab",
    displayName: "Open in New Tab Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-webview-fullpage",
    part: "webview-iframe",
    description: "The iframe element",
    displayName: "Iframe",
    cxOverridable: !0
  },
  {
    component: "ps-pype-webview-fullpage",
    part: "webview-group",
    description: "Focusable titled group wrapping the inline iframe",
    displayName: "webview-group",
    cxOverridable: !1
  },
  {
    component: "ps-pype-webview",
    part: "webview-root",
    description: "Outer wrapper element",
    displayName: "Webview Container",
    cxOverridable: !0
  },
  {
    component: "ps-pype-webview",
    part: "webview-group",
    description: "Focusable titled group wrapping the inline iframe",
    displayName: "Webview Group",
    cxOverridable: !0
  },
  {
    component: "ps-pype-webview",
    part: "webview-iframe",
    description: "The iframe element",
    displayName: "Iframe",
    cxOverridable: !0
  },
  {
    component: "ps-pype-launcher",
    part: "launcher-button",
    description: "The launcher button element",
    displayName: "Launcher Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-launcher",
    part: "launcher-logo",
    description: "The circular logo/avatar",
    displayName: "Launcher Logo",
    cxOverridable: !0
  },
  {
    component: "ps-pype-launcher",
    part: "launcher-title",
    description: "The visible label text",
    displayName: "Launcher Title",
    cxOverridable: !0
  },
  {
    component: "ps-pype-launcher",
    part: "launcher-mark-icon",
    description: "The Pypestream mark shown when no logo is set",
    displayName: "Pypestream Mark",
    cxOverridable: !0
  },
  {
    component: "ps-pype-floating-shell",
    part: "messenger-root",
    description: "The whole messenger panel",
    displayName: "Panel",
    cxOverridable: !0
  },
  {
    component: "ps-pype-floating-shell",
    part: "messenger-home-layer",
    description: "Layer behind the conversation that holds the home screen",
    displayName: "Home Layer",
    cxOverridable: !0
  },
  {
    component: "ps-pype-floating-shell",
    part: "messenger-conversation",
    description: "The card holding the conversation",
    displayName: "Conversation Card",
    cxOverridable: !0
  },
  {
    component: "ps-pype-floating-shell",
    part: "messenger-conversation-header",
    description: "Row above the messages holding the brand badge",
    displayName: "Conversation Header",
    cxOverridable: !0
  },
  {
    component: "ps-pype-floating-shell",
    part: "messenger-messages",
    description: "The scrolling message list",
    displayName: "Message List",
    cxOverridable: !0
  },
  {
    component: "ps-pype-floating-shell",
    part: "messenger-input-area",
    description: "The area around the message input",
    displayName: "Composer Area",
    cxOverridable: !0
  },
  {
    component: "ps-pype-floating-shell",
    part: "messenger-loading-welcome",
    description: "Welcome message shown while connecting",
    displayName: "Welcome While Connecting",
    cxOverridable: !0
  },
  {
    component: "ps-pype-floating-shell",
    part: "messenger-connecting-cover",
    description: "Cover shown while connecting",
    displayName: "Connecting Cover",
    cxOverridable: !0
  },
  {
    component: "ps-pype-floating-shell",
    part: "agent-assigned-notice",
    description: "Notice shown when a live agent joins",
    displayName: "Agent Joined Notice",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-shell",
    part: "page-card",
    description: "Centered content card",
    displayName: "Page Card",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-shell",
    part: "page-root",
    description: "The whole fullpage layout",
    displayName: "Page",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-shell",
    part: "page-top-region",
    description: "The sticky header bar",
    displayName: "Header",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-shell",
    part: "page-stage",
    description: "The main content area",
    displayName: "Main Area",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-shell",
    part: "page-agent-card",
    description: "The card holding a live-agent conversation",
    displayName: "Agent Chat Card",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-shell",
    part: "page-agent-messages-wrapper",
    description: "Scroll container of the agent chat",
    displayName: "Agent Chat Scroll Area",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-shell",
    part: "page-agent-messages",
    description: "The agent chat message list",
    displayName: "Agent Chat Messages",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-shell",
    part: "page-agent-footer",
    description: "Footer holding the agent chat input",
    displayName: "Agent Chat Footer",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-shell",
    part: "page-title",
    description: "The step heading",
    displayName: "Step Title",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-shell",
    part: "page-empty",
    description: "Shown when a step has no content",
    displayName: "Empty Step Text",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-shell",
    part: "page-notice",
    description: "A centered notice line",
    displayName: "Notice",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-shell",
    part: "page-embed-body",
    description: "Body of a full-page embed (e.g. a webview)",
    displayName: "Embed Body",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-shell",
    part: "page-footer",
    description: "Footer holding the input or the Next button",
    displayName: "Footer",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-shell",
    part: "page-next-btn",
    description: "The Next button under a full-page embed",
    displayName: "Next Button",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-shell",
    part: "page-menu-overlay",
    description: "Layer holding the open menu",
    displayName: "Menu Overlay",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-shell",
    part: "page-menu-backdrop",
    description: "Dimmed backdrop behind the open menu",
    displayName: "Menu Backdrop",
    cxOverridable: !0
  },
  {
    component: "ps-pype-fullpage-shell",
    part: "agent-assigned-notice",
    description: "Notice shown when a live agent joins",
    displayName: "Agent Joined Notice",
    cxOverridable: !0
  }
], u = [
  {
    component: "ps-pype-agent-status-banner",
    name: "status",
    type: `| 'waitingForAgent'
    | 'agentBusy'
    | 'agentAway'
    | ''`,
    description: "One of: waitingForAgent | agentBusy | agentAway",
    default: "''"
  },
  {
    component: "ps-pype-agent-status-banner",
    name: "skill",
    type: "string",
    description: "Routing skill from the transfer notice (optional)",
    default: "''"
  },
  {
    component: "ps-pype-agent-status-banner",
    name: "agent-name",
    type: "string",
    description: "Agent display name (optional, for away/left)",
    default: "''"
  },
  {
    component: "ps-pype-audio",
    name: "file-url",
    type: "string",
    description: "Audio source URL (from msg.file)",
    default: "''"
  },
  {
    component: "ps-pype-brand-area",
    name: "brand-image-url",
    type: "string",
    description: "Brand-moment image URL; full-bleed cover. When empty, the bundled default brand-moment image is shown.",
    default: "''"
  },
  {
    component: "ps-pype-brand-area",
    name: "customer-logo-url",
    type: "string",
    description: "Customer logo URL (straddling badge)",
    default: "''"
  },
  {
    component: "ps-pype-brand-area",
    name: "display-name",
    type: "string",
    description: "Customer display name (straddling badge)",
    default: "'Brand Background'"
  },
  {
    component: "ps-pype-brand-area",
    name: "hide-badge",
    type: "boolean",
    description: `Suppress the straddling badge. Set by the floating shell while the
conversation is showing, because the card then carries its own brand badge
and two would be on screen at once.

The card's badge is the one that survives, not this one: the whole home layer
is \`inert\` in conversation view, and \`inert\` removes the subtree from the
accessibility tree — so keeping this badge would leave the only VISIBLE brand
identity unreachable to assistive tech. It is also unreliable there: it is
centred on the band's bottom edge, so a short panel puts the card's top edge
above it and covers it entirely.

An explicit flag rather than blanking \`customerLogoUrl\`/\`displayName\`,
which would also work via \`hasBadge\` but only as an obscure side effect.`,
    default: "false"
  },
  {
    component: "ps-pype-brand-badge",
    name: "customer-logo-url",
    type: "string",
    description: "Customer logo image URL",
    default: "''"
  },
  {
    component: "ps-pype-brand-badge",
    name: "display-name",
    type: "string",
    description: "Customer display name",
    default: "'Header Logo & Name'"
  },
  {
    component: "ps-pype-brand-badge",
    name: "compact",
    type: "boolean",
    description: "Shrink the avatar to 32×32. Set by the conversation shell once the thread\nhas grown past the greeting, to reclaim vertical space (the transition +\nsizing are `plain`-variant only — the home `pill` badge is unaffected).",
    default: "false"
  },
  {
    component: "ps-pype-brand-badge",
    name: "variant",
    type: "'pill' | 'plain'",
    description: "`pill` (default) — logo+name on a rounded neutral background (home, over\nthe brand-moment edge). `plain` — logo+name inline, no background, name in\nthe surface's text color (conversation header).",
    default: "'pill'"
  },
  {
    component: "ps-pype-button",
    name: "variant",
    type: "ButtonVariant",
    description: "Visual style variant. `'image'` strips chrome — slot in an `<img>` to render an image-only clickable surface (parity with production's `ImageButton`).",
    default: "'primary'"
  },
  {
    component: "ps-pype-button",
    name: "size",
    type: "ButtonSize",
    description: "Button size",
    default: "'sm'"
  },
  {
    component: "ps-pype-button",
    name: "disabled",
    type: "boolean",
    description: "Disabled state",
    default: "false"
  },
  {
    component: "ps-pype-button",
    name: "full-width",
    type: "boolean",
    description: "Full width button",
    default: "false"
  },
  {
    component: "ps-pype-button",
    name: "label",
    type: "string",
    description: "Accessible name, rendered only on the inner button. Not `aria-label`: on the host, Chromium exposes it as a second named node, so screen readers announce the name twice.",
    default: "''"
  },
  {
    component: "ps-pype-button",
    name: "aria-expanded",
    type: "string",
    description: "Expanded state; forwarded to the inner button (menu/dialog triggers)"
  },
  {
    component: "ps-pype-button",
    name: "aria-haspopup",
    type: "string",
    description: "Popup type; forwarded to the inner button (menu/dialog triggers) CSS custom properties (image variant only — slotted `<img>` is in light DOM and can't be reached via `::part()`, so override the size caps and border radius through these inherited custom properties): - `--ps-button-image-max-inline-size` (default `300px`) - `--ps-button-image-max-block-size`  (default `200px`) - `--ps-button-image-border-radius`   (default `0.25rem`)"
  },
  {
    component: "ps-pype-chat-bubble",
    name: "side",
    type: "BubbleSide",
    description: "Message alignment: 'start' (bot) or 'end' (user)",
    default: "'start'"
  },
  {
    component: "ps-pype-chat-bubble",
    name: "header-label",
    type: "string",
    description: "Display name above bubble; falls back to i18n",
    default: "''"
  },
  {
    component: "ps-pype-chat-bubble",
    name: "formatted-time",
    type: "string | null",
    description: "Visible timestamp text (optional)",
    default: "null"
  },
  {
    component: "ps-pype-chat-bubble",
    name: "date-time",
    type: "string | null",
    description: "ISO datetime for the time element (optional)",
    default: "null"
  },
  {
    component: "ps-pype-chat-bubble",
    name: "bubble-variant",
    type: "BubbleVariant",
    description: "Color variant: 'primary' or 'accent'",
    default: "'primary'"
  },
  {
    component: "ps-pype-chat-bubble",
    name: "animation",
    type: "boolean",
    description: "Whether to animate entrance",
    default: "false"
  },
  {
    component: "ps-pype-chat-bubble",
    name: "no-tail",
    type: "boolean",
    description: "Hide the bubble's tail/pointer. Set on every bubble except the last in a run of consecutive same-side bubbles, so a group reads as one visual cluster with a single tail.",
    default: "false"
  },
  {
    component: "ps-pype-chat-bubble",
    name: "thinking",
    type: "boolean",
    description: `Render an animated dots loader in place of the slotted body. Not a tab stop
meanwhile: it unmounts when the reply lands, dropping focus to the document.`,
    default: "false"
  },
  {
    component: "ps-pype-chat-bubble",
    name: "show-avatar",
    type: "boolean",
    description: "Render the `avatar` slot beside the bubble. Uses DaisyUI's `chat-image`\ncolumn so placement and bottom-alignment follow `side` and RTL.",
    default: "false"
  },
  {
    component: "ps-pype-chat-bubble",
    name: "message-id",
    type: "string",
    description: `Registry key for the label-chain. Preserves chronological order
across virtualization. Absent → registration is skipped silently,
allowing decorative bubble usages outside the message flow.`,
    default: "''"
  },
  {
    component: "ps-pype-chat-bubble",
    name: "sr-name",
    type: "string",
    description: 'Name for the screen-reader "who is speaking" prefix. Distinct from\n`headerLabel` on purpose: the bot\'s name is announced but NOT shown, so the\nvisible header stays empty while this carries a value. Both come from\n`resolveSenderName` — this component only picks wording.',
    default: "''"
  },
  {
    component: "ps-pype-chat-bubble",
    name: "sender-kind",
    type: "'human' | 'bot'",
    description: `Distinguishes an unnamed HUMAN ("Agent says") from an unnamed bot
("Bot says"). The consumer case is derived from \`side\` instead, so a caller
cannot forget it and silently mis-announce the user's own message.`,
    default: "'bot'"
  },
  {
    component: "ps-pype-chat-bubble",
    name: "hide-header",
    type: "boolean",
    description: "",
    default: "false"
  },
  {
    component: "ps-pype-chat-bubble",
    name: "thinking-label",
    type: "string",
    description: `The loader's accessible name; empty falls back to "Bot is thinking".`,
    default: "''"
  },
  {
    component: "ps-pype-chat-bubble",
    name: "quiet-status",
    type: "boolean",
    description: "Keep the loader's status out of the live region (agent typing).",
    default: "false"
  },
  {
    component: "ps-pype-chat-ended-menu",
    name: "ended-text",
    type: "string",
    description: "Message shown when chat has ended",
    default: "''"
  },
  {
    component: "ps-pype-chat-ended-menu",
    name: "show-actions",
    type: "boolean",
    description: `Whether to offer the actions as well as the statement.

One row is rendered per ended conversation, so a sitting with five ended
chats shows five statements — but only the latest one can be acted on:
"Start New Conversation" against an archived conversation is meaningless.
The renderer sets this for the last row of an ended chat; the fullpage
ended page sets it because that page IS the latest conversation.`,
    default: "false"
  },
  {
    component: "ps-pype-chat-ended-menu",
    name: "download-text",
    type: "string",
    description: "Download button label",
    default: "''"
  },
  {
    component: "ps-pype-chat-ended-menu",
    name: "download-aria-label",
    type: "string",
    description: "Download button accessible name",
    default: "''"
  },
  {
    component: "ps-pype-chat-ended-menu",
    name: "new-chat-text",
    type: "string",
    description: "Start new conversation button label",
    default: "''"
  },
  {
    component: "ps-pype-chat-ended-menu",
    name: "actions-disabled",
    type: "boolean",
    description: `Disables all actions during parent transitions. Prevents a double-click
race on "Start new conversation" while the round-trip is in flight.`,
    default: "false"
  },
  {
    component: "ps-pype-connecting",
    name: "logo-url",
    type: "string",
    description: "Customer logo URL. Empty falls back to the mark.",
    default: "''"
  },
  {
    component: "ps-pype-connecting",
    name: "variant",
    type: "'card' | 'page'",
    description: "`card` (default), sized for the floating conversation card; `page` is smaller, for the fullpage page-card.",
    default: "'card'"
  },
  {
    component: "ps-pype-document",
    name: "file-url",
    type: "string",
    description: "Document download URL (from msg.file)",
    default: "''"
  },
  {
    component: "ps-pype-dyte",
    name: "no-tail",
    type: "boolean",
    description: "",
    default: "false"
  },
  {
    component: "ps-pype-fullpage-menu",
    name: "display-name",
    type: "string",
    description: "Customer display name (panel title)",
    default: "'Full Page Menu'"
  },
  {
    component: "ps-pype-fullpage-menu",
    name: "is-ended",
    type: "boolean",
    description: "When true, hides the persistent-menu options",
    default: "false"
  },
  {
    component: "ps-pype-fullpage-nav",
    name: "customer-logo-url",
    type: "string",
    description: "Customer logo URL",
    default: "''"
  },
  {
    component: "ps-pype-fullpage-nav",
    name: "display-name",
    type: "string",
    description: "Customer display name",
    default: "'Full Page Header'"
  },
  {
    component: "ps-pype-fullpage-nav",
    name: "subtitle",
    type: "string",
    description: 'Agent-context subtitle (e.g. "Talking with Jane")',
    default: "''"
  },
  {
    component: "ps-pype-fullpage-nav",
    name: "menu-open",
    type: "boolean",
    description: "Whether the menu is currently open (aria-expanded)",
    default: "false"
  },
  {
    component: "ps-pype-fullpage-nav",
    name: "has-active-conversation",
    type: "boolean",
    description: "Show the End Chat button",
    default: "false"
  },
  {
    component: "ps-pype-home",
    name: "brand-image-url",
    type: "string",
    description: "Brand-moment hero image URL (cover)",
    default: "''"
  },
  {
    component: "ps-pype-home",
    name: "customer-logo-url",
    type: "string",
    description: "Customer logo URL",
    default: "''"
  },
  {
    component: "ps-pype-home",
    name: "display-name",
    type: "string",
    description: "Customer display name",
    default: "'Home Screen'"
  },
  {
    component: "ps-pype-home",
    name: "hide-pypestream-branding",
    type: "boolean",
    description: 'Hide the "Powered by Pypestream" footer (whitelabel) Ended / has-conversation state is NOT passed as a prop — it\'s derived from the machine-driven shared state (`chatState` / `sessionContext`, synced by `PypeStateController` on the base class), so the home screen reacts to the XState machine directly without the shell prop-drilling stale attributes.',
    default: "false"
  },
  {
    component: "ps-pype-home",
    name: "hide-brand-badge",
    type: "boolean",
    description: "Forwarded to `ps-pype-brand-area`. The shell sets it while the conversation\ncard is showing, so the hero's straddling badge and the card's own badge are\nnever both on screen. See the property's docs on the brand area.",
    default: "false"
  },
  {
    component: "ps-pype-image",
    name: "file-url",
    type: "string",
    description: "Image source URL (from msg.file)",
    default: "''"
  },
  {
    component: "ps-pype-input",
    name: "attachment-enabled",
    type: "boolean",
    description: "Whether attachment is offered right now — renders the paperclip. The shell\ndecides WHEN (live agent chat only); this component never reads chat state,\nsame contract as `mode`/`disabled`.",
    default: "false"
  },
  {
    component: "ps-pype-input",
    name: "disabled",
    type: "boolean",
    description: "Disables input AND send button",
    default: "false"
  },
  {
    component: "ps-pype-input",
    name: "readonly",
    type: "boolean",
    description: "Locks typing but keeps the send button live. Used by multi-select pickers so the user can submit their selection through this shared send button instead of an inline confirm. `disabled` always wins over `readonly` when both are set.",
    default: "false"
  },
  {
    component: "ps-pype-input",
    name: "placeholder",
    type: "string",
    description: "Placeholder text (also the `prompt` bar's label and the `reconnect` bar's status text); supplied by the shell's context-aware derivation",
    default: "''"
  },
  {
    component: "ps-pype-input",
    name: "mode",
    type: `| 'text'
    | 'password'
    | 'none'
    | 'prompt'
    | 'reconnect'`,
    description: "Input mode: 'text' (default), 'password', 'none', 'prompt' (non-editable force-interaction bar), or 'reconnect' (network-degraded status + Reconnect button)",
    default: "'text'"
  },
  {
    component: "ps-pype-input",
    name: "reconnect-pending",
    type: "boolean",
    description: "`reconnect` mode only: a RETRY is already in flight (`reconnecting`) so the\nReconnect button is disabled. The shell derives this from `networkState`\n(`deriveInputState`) — this component never reads the store's network state\nitself (pure props-in).",
    default: "false"
  },
  {
    component: "ps-pype-input",
    name: "value",
    type: "string | undefined",
    description: "Programmatic value override. `undefined` means \"no override\" — the\nuser's in-progress typing is preserved. Any string (including '')\noverwrites `_value` on the next reactive update.",
    default: "undefined"
  },
  {
    component: "ps-pype-input",
    name: "clearable",
    type: "boolean",
    description: 'Show a clear (×) button. Set by the shell from `configureInput({ clearable })`\n— a component (multi-select listpicker / CX asset) that mirrors a selection\noffers "clear my selection". Clicking clears the field and emits\n`ps-input-clear`; the owning component listens for it to reset its selection.',
    default: "false"
  },
  {
    component: "ps-pype-overlay",
    name: "expandable",
    type: "boolean",
    description: "Whether the slotted content supports expansion to full-screen.",
    default: "false"
  },
  {
    component: "ps-pype-overlay",
    name: "overlay-title",
    type: "string",
    description: "Header title for the slotted embed. Empty → toolbar shows no title.",
    default: "''"
  },
  {
    component: "ps-pype-overlay",
    name: "newtab-url",
    type: "string",
    description: "External URL for the expanded-state keyboard-trap escape button. Empty →\nno escape button (the embed doesn't support opening in a new tab). Only\nrendered when expanded — see `_renderExpanded`.",
    default: "''"
  },
  {
    component: "ps-pype-scroll-to-bottom",
    name: "visible",
    type: "boolean",
    description: "Whether to render at all",
    default: "false"
  },
  {
    component: "ps-pype-scroll-to-bottom",
    name: "notification-count",
    type: "number",
    description: "Unread messages to badge (0 = no badge)",
    default: "0"
  },
  {
    component: "ps-pype-solution-request",
    name: "no-tail",
    type: "boolean",
    description: "",
    default: "false"
  },
  {
    component: "ps-pype-text-message",
    name: "no-tail",
    type: "boolean",
    description: "Hide the inner bubble's tail. Set by the component boundary (which\nforwards the `no-tail` attribute the renderer binds) when this message\nis not the last in a run of consecutive same-side bubbles.",
    default: "false"
  },
  {
    component: "ps-pype-top-bar",
    name: "view",
    type: "TopBarView",
    description: "Current view: 'conversation' or 'home'",
    default: "'conversation'"
  },
  {
    component: "ps-pype-top-bar",
    name: "has-active-conversation",
    type: "boolean",
    description: "Whether there is an active conversation",
    default: "false"
  },
  {
    component: "ps-pype-top-bar",
    name: "over-brand-image",
    type: "boolean",
    description: "Whether a brand-moment image sits behind the (transparent, floating) top\nbar. When true the icons go light to clear the deterministic dark scrim\n`ps-pype-brand-area` paints over the top strip; when false they keep\n`text-primary-content` against the `--color-primary` backstop. Set by the\nshell from the same signal that drives the brand image + scrim.",
    default: "false"
  },
  {
    component: "ps-pype-top-bar",
    name: "hide-minimize",
    type: "boolean",
    description: "Hide the minimize button — e.g. in the window render target where the OS window owns it.",
    default: "false"
  },
  {
    component: "ps-pype-top-bar",
    name: "hide-close",
    type: "boolean",
    description: "Hide the close button — e.g. in the window render target where the OS window owns it.",
    default: "false"
  },
  {
    component: "ps-pype-tray",
    name: "auto-expand",
    type: "boolean",
    description: "Shell-driven expand/collapse based on scroll position.",
    default: "true"
  },
  {
    component: "ps-pype-tray",
    name: "show-collapse-button",
    type: "boolean",
    description: `Whether to render the visible collapse handle. Reflected so the shell's
stylesheet can zero the peek height when the tray is pinned open — the
shell styles this host, and only an attribute crosses that boundary.`,
    default: "true"
  },
  {
    component: "ps-pype-tray",
    name: "auto-collapse-on-convo-click",
    type: "boolean",
    description: "Policy flag consumed by the shell — the tray doesn't watch sibling clicks itself.",
    default: "true"
  },
  {
    component: "ps-pype-tray",
    name: "no-reveal",
    type: "boolean",
    description: "Skip the bottom→top entrance reveal (host opted out of entrance motion)"
  },
  {
    component: "ps-pype-tray",
    name: "message-id",
    type: "string",
    description: "ID of the current embed message. Identity only — openness is the shell's.",
    default: "''"
  },
  {
    component: "ps-pype-typing-indicator",
    name: "kind",
    type: "'agent' | 'bot'",
    description: "Who is composing; picks the announcement.",
    default: "'agent'"
  },
  {
    component: "ps-pype-typing-indicator",
    name: "agent-name",
    type: "string",
    description: "Agent display name shown above the dots.",
    default: "''"
  },
  {
    component: "ps-pype-unsupported",
    name: "label",
    type: "string",
    description: "Display text from the app object or message",
    default: "''"
  },
  {
    component: "ps-pype-unsupported",
    name: "msg-type",
    type: "string",
    description: "The unhandled msg_type or app_object.type",
    default: "''"
  },
  {
    component: "ps-pype-video",
    name: "file-url",
    type: "string",
    description: "Video source URL (from msg.file)",
    default: "''"
  },
  {
    component: "ps-pype-launcher",
    name: "label",
    type: "string",
    description: "Button label text",
    default: "''"
  },
  {
    component: "ps-pype-launcher",
    name: "disabled",
    type: "boolean",
    description: "Whether the button is disabled",
    default: "false"
  },
  {
    component: "ps-pype-launcher",
    name: "aria-label",
    type: "string",
    description: "Accessible name for the button"
  },
  {
    component: "ps-pype-launcher",
    name: "customer-logo-url",
    type: "string",
    description: "Brand logo for the logo circle; the Pypestream mark shows when unset.",
    default: "''"
  },
  {
    component: "ps-pype-launcher",
    name: "expanded",
    type: "boolean",
    description: "Whether the panel this launcher opens is currently showing.",
    default: "false"
  },
  {
    component: "ps-pype-floating-shell",
    name: "custom-css",
    type: "string",
    description: ""
  },
  {
    component: "ps-pype-floating-shell",
    name: "hide-window-controls",
    type: "boolean",
    description: "Window render target: hide the top-bar minimize/close chrome (the OS popup\nwindow owns those). Set by `FloatingModality` from `config.target`."
  },
  {
    component: "ps-pype-fullpage-shell",
    name: "custom-css",
    type: "string",
    description: ""
  }
], m = [
  {
    component: "ps-pype-buttons-fullpage",
    name: "ps-action",
    description: "Dispatched with `{ message: string, appObject: AppObject | null }` on option click"
  },
  {
    component: "ps-pype-buttons",
    name: "ps-action",
    description: "Dispatched with `{ message: string, appObject: AppObject | null }` on option click"
  },
  {
    component: "ps-pype-button",
    name: "button-click",
    description: "Dispatched on click (detail: void)"
  },
  {
    component: "ps-pype-carousel-fullpage",
    name: "ps-action",
    description: "Dispatched with `{ message: string, appObject: AppObject | null }` on action click"
  },
  {
    component: "ps-pype-carousel",
    name: "ps-action",
    description: "Dispatched with `{ message: string, appObject: AppObject | null }` on action click"
  },
  {
    component: "ps-pype-chat-ended-menu",
    name: "download-transcript",
    description: 'User clicked "Download Transcript"'
  },
  {
    component: "ps-pype-chat-ended-menu",
    name: "start-new",
    description: 'User clicked "Start New Conversation"'
  },
  {
    component: "ps-pype-chat-ended-menu",
    name: "chat-ended-ready",
    description: "Actions mounted; the shell moves focus to `a11yFocusable`"
  },
  {
    component: "ps-pype-datepicker-fullpage",
    name: "ps-action",
    description: "Dispatched with `{ message: string, appObject: AppObject | null }` on confirm"
  },
  {
    component: "ps-pype-datepicker",
    name: "ps-action",
    description: "Dispatched with `{ message: string, appObject: AppObject | null }` on confirm"
  },
  {
    component: "ps-pype-file-upload-fullpage",
    name: "ps-action",
    description: "Dispatched with `{ message: string, appObject: AppObject | null }` on successful upload"
  },
  {
    component: "ps-pype-file-upload",
    name: "ps-action",
    description: "Dispatched with `{ message: string, appObject: AppObject | null }` on successful upload"
  },
  {
    component: "ps-pype-fullpage-menu",
    name: "ps-action",
    description: "Persistent-menu option clicked; detail: { message, appObject }."
  },
  {
    component: "ps-pype-fullpage-menu",
    name: "download-transcript",
    description: "Download Transcript clicked."
  },
  {
    component: "ps-pype-fullpage-menu",
    name: "menu-close",
    description: "Close button clicked."
  },
  {
    component: "ps-pype-fullpage-nav",
    name: "menu-toggle",
    description: "Home/menu button clicked (open or close the menu)."
  },
  {
    component: "ps-pype-fullpage-nav",
    name: "end-chat-click",
    description: "End Chat button clicked."
  },
  {
    component: "ps-pype-home",
    name: "ps-action",
    description: 'Menu option clicked; detail: { message, appObject }. appObject is shaped per the persistent_menu wire spec — includes `embed_type: "persistent_menu"`, `set_value`, and `bot_value` (`int_ref*code`).'
  },
  {
    component: "ps-pype-home",
    name: "return-to-conversation",
    description: '"Return to Conversation" clicked'
  },
  {
    component: "ps-pype-home",
    name: "download-transcript",
    description: '"Download Transcript" clicked'
  },
  {
    component: "ps-pype-input",
    name: "message-send",
    description: "Dispatched with `{ message: string }` when user submits"
  },
  {
    component: "ps-pype-input",
    name: "composing",
    description: "Dispatched on every keystroke with `{ value: string }`."
  },
  {
    component: "ps-pype-input",
    name: "ps-input-clear",
    description: "Dispatched when the clear (×) button is clicked; the owning component (e.g. multi-select listpicker) resets its selection. The shell debounces these into typing-start/stop pings."
  },
  {
    component: "ps-pype-input",
    name: "ps-attach-file",
    description: "The user picked a file: `{ file: File }`. The SHELL uploads it and pushes the result back down via `attachment` — WC primitives do not fetch."
  },
  {
    component: "ps-pype-input",
    name: "ps-attach-clear",
    description: "The user removed the staged file (or dismissed a failure). The shell aborts any upload in flight."
  },
  {
    component: "ps-pype-input",
    name: "pype-retry",
    description: "User clicked Reconnect (offline). Caught by `<ps-pype>`."
  },
  {
    component: "ps-pype-listpicker-fullpage",
    name: "ps-action",
    description: "Dispatched with `{ message, appObject }` on submit. Single-select fires on the option click; multi-select fires when the shared input's send button is pressed."
  },
  {
    component: "ps-pype-listpicker-fullpage",
    name: "ps-configure-input",
    description: "Mirrors the in-progress selection into the shared input field (label preview + readonly lock)."
  },
  {
    component: "ps-pype-listpicker-fullpage",
    name: "embed-composing",
    description: "Search keystrokes, so the shell drives the agent-side typing indicator (legacy parity)."
  },
  {
    component: "ps-pype-listpicker",
    name: "ps-action",
    description: "Dispatched with `{ message, appObject }` on submit. Single-select fires on the option click; multi-select fires when the shared input's send button is pressed."
  },
  {
    component: "ps-pype-listpicker",
    name: "ps-configure-input",
    description: "Mirrors the in-progress selection into the shared input field (label preview + readonly lock)."
  },
  {
    component: "ps-pype-listpicker",
    name: "embed-composing",
    description: "Search keystrokes, so the shell drives the agent-side typing indicator (legacy parity)."
  },
  {
    component: "ps-pype-location-fullpage",
    name: "ps-silent-send",
    description: "Coordinates, or the failure sentinel"
  },
  {
    component: "ps-pype-location",
    name: "ps-silent-send",
    description: "Coordinates, or the failure sentinel"
  },
  {
    component: "ps-pype-overlay",
    name: "ps-overlay-ready",
    description: "Dialog DOM mounted (firstUpdated); shell sets the focus trap + initial focus"
  },
  {
    component: "ps-pype-overlay",
    name: "ps-overlay-close",
    description: "Close button clicked (shell handles backend message)"
  },
  {
    component: "ps-pype-overlay",
    name: "ps-overlay-expand",
    description: "Overlay entered full-screen state"
  },
  {
    component: "ps-pype-overlay",
    name: "ps-overlay-reduce",
    description: "Overlay left full-screen state (reduce, close while expanded, or unmount while expanded)"
  },
  {
    component: "ps-pype-overlay",
    name: "ps-open-url",
    description: "Escape button clicked; detail `{ url }` (shell opens it in a new tab)"
  },
  {
    component: "ps-pype-scroll-to-bottom",
    name: "scroll-to-bottom",
    description: "User clicked the button (no detail). Shell handles the scroll + mark-as-read."
  },
  {
    component: "ps-pype-secure-text",
    name: "ps-secure-send",
    description: "Internal. `{ message, appObject }` with the typed cleartext + a `TextAppObject` answer (`free_text: false`). Recognised only by the shell."
  },
  {
    component: "ps-pype-solution-request",
    name: "ps-open-solution",
    description: "`{ messageId, url, closeMessage }` when the user activates the link. Caught by the shell, which opens the overlay webview."
  },
  {
    component: "ps-pype-star-fullpage",
    name: "ps-action",
    description: "Dispatched with `{ message: string, appObject: AppObject | null }` on submit"
  },
  {
    component: "ps-pype-star",
    name: "ps-action",
    description: "Dispatched with `{ message: string, appObject: AppObject | null }` on submit"
  },
  {
    component: "ps-pype-timepicker-fullpage",
    name: "ps-action",
    description: "Dispatched with `{ message: string, appObject: AppObject | null }` on confirm"
  },
  {
    component: "ps-pype-timepicker",
    name: "ps-action",
    description: "Dispatched with `{ message: string, appObject: AppObject | null }` on confirm"
  },
  {
    component: "ps-pype-top-bar",
    name: "home-click",
    description: "Home button clicked (conversation view)"
  },
  {
    component: "ps-pype-top-bar",
    name: "back-click",
    description: "Back button clicked (home view)"
  },
  {
    component: "ps-pype-top-bar",
    name: "minimize-click",
    description: "Minimize button clicked"
  },
  {
    component: "ps-pype-top-bar",
    name: "close-click",
    description: "Close button clicked"
  },
  {
    component: "ps-pype-launcher",
    name: "launch",
    description: "Dispatched when the launcher button is clicked"
  }
], y = [
  {
    component: "ps-pype-button",
    name: "(default)",
    description: "Button label content"
  },
  {
    component: "ps-pype-chat-bubble",
    name: "(default)",
    description: "Bubble body content (message text, markdown, app-object, etc.)"
  },
  {
    component: "ps-pype-chat-bubble",
    name: "avatar",
    description: "Agent/bot avatar shown beside the bubble (only when `show-avatar` is set). Slot in an `<img>` or `<ps-pype-avatar>`."
  },
  {
    component: "ps-pype-overlay",
    name: "(default)",
    description: "Default slot for the active overlay embed"
  },
  {
    component: "ps-pype-tray",
    name: "(default)",
    description: "Default slot for the active tray embed"
  }
], i = [
  {
    tagName: "ps-pype-agent-status-banner",
    className: "PsPypeAgentStatusBanner",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Agent Status Banner"
  },
  {
    tagName: "ps-pype-audio",
    className: "PsPypeAudio",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Audio"
  },
  {
    tagName: "ps-pype-brand-area",
    className: "PsPypeBrandArea",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Brand Background"
  },
  {
    tagName: "ps-pype-brand-badge",
    className: "PsPypeBrandBadge",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Header Logo & Name"
  },
  {
    tagName: "ps-pype-buttons-fullpage",
    className: "PsPypeButtonsFullpage",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Buttons (Fullpage)"
  },
  {
    tagName: "ps-pype-buttons",
    className: "PsPypeButtons",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Buttons"
  },
  {
    tagName: "ps-pype-button",
    className: "PsPypeButton",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Button"
  },
  {
    tagName: "ps-pype-carousel-fullpage",
    className: "PsPypeCarouselFullpage",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Carousel (Fullpage)"
  },
  {
    tagName: "ps-pype-carousel",
    className: "PsPypeCarousel",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Carousel"
  },
  {
    tagName: "ps-pype-chat-bubble",
    className: "PsPypeChatBubble",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Chat Bubble"
  },
  {
    tagName: "ps-pype-chat-ended-menu",
    className: "PsPypeChatEndedMenu",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Chat Ended Menu"
  },
  {
    tagName: "ps-pype-connecting",
    className: "PsPypeConnecting",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Loading Screen"
  },
  {
    tagName: "ps-pype-datepicker-fullpage",
    className: "PsPypeDatepickerFullpage",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Datepicker (Fullpage)"
  },
  {
    tagName: "ps-pype-datepicker",
    className: "PsPypeDatepicker",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Datepicker"
  },
  {
    tagName: "ps-pype-deeplink",
    className: "PsPypeDeeplink",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Deep Link"
  },
  {
    tagName: "ps-pype-document",
    className: "PsPypeDocument",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Document"
  },
  {
    tagName: "ps-pype-dyte",
    className: "PsPypeDyte",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Video Call"
  },
  {
    tagName: "ps-pype-file-transfer",
    className: "PsPypeFileTransfer",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "File Attachment"
  },
  {
    tagName: "ps-pype-file-upload-fullpage",
    className: "PsPypeFileUploadFullpage",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "File Upload (Fullpage)"
  },
  {
    tagName: "ps-pype-file-upload",
    className: "PsPypeFileUpload",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "File Upload"
  },
  {
    tagName: "ps-pype-fullpage-menu",
    className: "PsPypeFullpageMenu",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Full Page Menu"
  },
  {
    tagName: "ps-pype-fullpage-nav",
    className: "PsPypeFullpageNav",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Full Page Header"
  },
  {
    tagName: "ps-pype-home",
    className: "PsPypeHome",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Home Screen"
  },
  {
    tagName: "ps-pype-image",
    className: "PsPypeImage",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Image"
  },
  {
    tagName: "ps-pype-input",
    className: "PsPypeInput",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Message Input"
  },
  {
    tagName: "ps-pype-listpicker-fullpage",
    className: "PsPypeListpickerFullpage",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Listpicker (Fullpage)"
  },
  {
    tagName: "ps-pype-listpicker",
    className: "PsPypeListpicker",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Listpicker"
  },
  {
    tagName: "ps-pype-location-fullpage",
    className: "PsPypeLocationFullpage",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Location (Fullpage)"
  },
  {
    tagName: "ps-pype-location",
    className: "PsPypeLocation",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Location"
  },
  {
    tagName: "ps-pype-notice",
    className: "PsPypeNotice",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Notice"
  },
  {
    tagName: "ps-pype-overlay",
    className: "PsPypeOverlay",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Embed Popup"
  },
  {
    tagName: "ps-pype-response-placeholder",
    className: "PsPypeResponsePlaceholder",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Response Placeholder"
  },
  {
    tagName: "ps-pype-scroll-to-bottom",
    className: "PsPypeScrollToBottom",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Scroll To Bottom"
  },
  {
    tagName: "ps-pype-secure-text",
    className: "PsPypeSecureText",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Secure Input"
  },
  {
    tagName: "ps-pype-solution-request",
    className: "PsPypeSolutionRequest",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Solution Request Message"
  },
  {
    tagName: "ps-pype-star-fullpage",
    className: "PsPypeStarFullpage",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Star Rating (Fullpage)"
  },
  {
    tagName: "ps-pype-star",
    className: "PsPypeStar",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Star Rating"
  },
  {
    tagName: "ps-pype-timepicker-fullpage",
    className: "PsPypeTimepickerFullpage",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Timepicker (Fullpage)"
  },
  {
    tagName: "ps-pype-timepicker",
    className: "PsPypeTimepicker",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Timepicker"
  },
  {
    tagName: "ps-pype-text-message",
    className: "PsPypeTextMessage",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Text Message"
  },
  {
    tagName: "ps-pype-top-bar",
    className: "PsPypeTopBar",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Chat Window Header"
  },
  {
    tagName: "ps-pype-tray",
    className: "PsPypeTray",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Embed Tray"
  },
  {
    tagName: "ps-pype-typing-indicator",
    className: "PsPypeTypingIndicator",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Typing Indicator"
  },
  {
    tagName: "ps-pype-unsupported",
    className: "PsPypeUnsupported",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Unsupported Content"
  },
  {
    tagName: "ps-pype-video",
    className: "PsPypeVideo",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Video"
  },
  {
    tagName: "ps-pype-webview-fullpage",
    className: "PsPypeWebviewFullpage",
    description: "",
    superclass: "PsPypeWebview",
    displayName: "Webview (Fullpage)"
  },
  {
    tagName: "ps-pype-webview",
    className: "PsPypeWebview",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Webview"
  },
  {
    tagName: "ps-pype-launcher",
    className: "PsPypeLauncherWC",
    description: "",
    superclass: "PypeBaseElement",
    displayName: "Launcher Button"
  },
  {
    tagName: "ps-pype-floating-shell",
    className: "PypeFloatingShell",
    description: `PypeFloatingShell — floating modality layout.

Composes the messenger UI for the "floating" modality: a popup panel with a
z-index stack — home screen (z10, full-panel, owns its own brand-moment
hero), conversation overlay (z20, slides), top bar (z30) floating over both.

All business logic lives in PypeShellController (shared across modalities).
This file is ONLY layout and composition — the render() method.`,
    superclass: "PypeBaseElement",
    displayName: "Chat Window"
  },
  {
    tagName: "ps-pype-fullpage-shell",
    className: "PypeFullpageShell",
    description: `PypeFullpageShell — fullpage modality, step-based layout.

Renders ONE bot prompt at a time as a centered "page".
History is hidden; user-sent messages are hidden; consecutive bot messages
collapse into a single page (the latest bot run, walked back from the end
until the most recent user message). Page transitions fade in via CSS.

Modality-agnostic business logic lives in PypeShellController (unchanged).
This shell just decides what subset of the message list becomes the
current page and how it's laid out.

Zone routing collapses in fullpage: the active embed (carousel, listpicker,
webview, etc. — declared as tray/overlay zone elsewhere) renders inline as
the page content, since the page IS the modality.`,
    superclass: "PypeBaseElement",
    displayName: "Full Page Layout"
  }
];
function b(t) {
  const e = n().get(t);
  return e ? e.parts : r.filter(
    (a) => a.component === t && a.cxOverridable
  );
}
function s() {
  const t = /* @__PURE__ */ new Set();
  for (const e of r)
    e.cxOverridable && t.add(e.component);
  for (const [e, a] of n())
    a.parts.length > 0 && t.add(e);
  return [...t];
}
function h() {
  const t = new Set(s()), e = i.filter((p) => t.has(p.tagName)), a = [];
  for (const [p, o] of n())
    o.parts.length !== 0 && a.push({
      tagName: p,
      className: "",
      description: "",
      superclass: "PypeCoreElement",
      displayName: o.displayName
    });
  return [...e, ...a];
}
const g = [
  { id: "sharp", label: "Sharp", value: "0" },
  { id: "rounded", label: "Rounded", value: "0.25rem" },
  { id: "soft", label: "Soft", value: "0.5rem" },
  { id: "pill", label: "Pill", value: "1rem" }
], v = [
  { id: "xs", label: "xs", value: "0.1875rem" },
  { id: "sm", label: "sm", value: "0.21875rem" },
  { id: "md", label: "md", value: "0.25rem" },
  { id: "lg", label: "lg", value: "0.28125rem" },
  { id: "xl", label: "xl", value: "0.3125rem" }
], f = [
  { id: "0", label: "0", value: "0px" },
  { id: "1", label: "1", value: "1px" },
  { id: "2", label: "2", value: "2px" },
  { id: "3", label: "3", value: "3px" },
  { id: "4", label: "4", value: "4px" }
], N = {
  depth: { off: "0", on: "1" },
  noise: { off: "0", on: "0.1" }
}, x = [
  {
    id: "base",
    label: "Base",
    bgTokens: ["--color-base-100", "--color-base-200", "--color-base-300"],
    fgToken: "--color-base-content"
  },
  {
    id: "primary",
    label: "Primary",
    bgToken: "--color-primary",
    fgToken: "--color-primary-content"
  },
  {
    id: "secondary",
    label: "Secondary",
    bgToken: "--color-secondary",
    fgToken: "--color-secondary-content"
  },
  {
    id: "accent",
    label: "Accent",
    bgToken: "--color-accent",
    fgToken: "--color-accent-content"
  },
  {
    id: "neutral",
    label: "Neutral",
    bgToken: "--color-neutral",
    fgToken: "--color-neutral-content"
  },
  {
    id: "info",
    label: "Info",
    bgToken: "--color-info",
    fgToken: "--color-info-content"
  },
  {
    id: "success",
    label: "Success",
    bgToken: "--color-success",
    fgToken: "--color-success-content"
  },
  {
    id: "warning",
    label: "Warning",
    bgToken: "--color-warning",
    fgToken: "--color-warning-content"
  },
  {
    id: "error",
    label: "Error",
    bgToken: "--color-error",
    fgToken: "--color-error-content"
  }
];
export {
  u as ATTRS_MANIFEST,
  k as AUTO_LANGUAGE,
  f as BORDER_PRESETS,
  x as COLOR_FAMILIES,
  i as COMPONENTS,
  T as DAISY_THEMES,
  H as DEFAULT_SHELL_SIZE,
  N as EFFECT_VALUES,
  m as EVENTS_MANIFEST,
  L as HOST_FIELDS,
  P as MODALITIES,
  R as MODALITY_IGNORED_FIELDS,
  r as PARTS_MANIFEST,
  M as PLATFORM_FIELDS,
  C as PYPE_LANGUAGE_CODES,
  g as RADIUS_PRESETS,
  v as SIZE_PRESETS,
  y as SLOTS_MANIFEST,
  B as THEME_COLOR_SCHEMES,
  S as THEME_TOKEN_VALUES,
  c as TOKENS_MANIFEST,
  d as TOKEN_GROUP_LABELS,
  D as clearSessionComponentParts,
  U as createDefaultBrandingSection,
  z as createDefaultDesignSection,
  W as createDefaultShellSection,
  j as createDefaultWidgetAppConfig,
  Y as fetchWidgetAppDesign,
  E as findRefusedStyleFetches,
  h as getComponentEntriesWithParts,
  s as getComponentsWithParts,
  b as getPartsForComponent,
  _ as ignoredReasonFor,
  V as modalityUsesField,
  G as projectOwnedBlob,
  A as setSessionComponentParts,
  q as splitBlobPath
};
//# sourceMappingURL=customization.js.map
